module.exports = __webpack_public_path__ + "static/village_slide_img05-57ab3151c67a7f59759de6009f61af37.png";